// @flow
// import stores from './stores.data';
import { ofType, StateObservable } from 'redux-observable';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { of } from 'rxjs';
import { getStoresApi } from './api';
import Paginator from '../../common/Paginator';

import type { Category, OnlineStore } from '../../entities';
import type { HTTPError } from '../../error';
import type { Observable } from 'rxjs';
import type { RootState } from '../index';

export type StoresFilter = {
  categories?: string[];
  name?: string;
  sort?: string;
  order?: string;
};

type StoresAction = {
  +type: string;
  +stores?: OnlineStore[];
  +filters?: StoresFilter;
  +error?: HTTPError;
  +resetPagination?: boolean;
};

export type StoresState = {
  isFetchingStores?: boolean;
  fetchStoresError?: HTTPError;
  stores?: OnlineStore[];
  page?: number;
  pageCanAsk?: boolean;
};

//Actions
const STORES_FETCH_REQUEST = 'STORES_FETCH_REQUEST';
const STORES_FETCH_SUCCESS = 'STORES_FETCH_SUCCESS';
const STORES_FETCH_ERROR = 'STORES_FETCH_ERROR';
const STORES_RESET_STATE = 'STORES_RESET_STATE';

export function fetchStores(filters: StoresFilter, resetPagination?: boolean): StoresAction {
  return {
    type: STORES_FETCH_REQUEST,
    filters,
    resetPagination,
  };
}

export function fetchStoresSuccess(stores: OnlineStore[]): StoresAction {
  return {
    type: STORES_FETCH_SUCCESS,
    stores,
  };
}

export function fetchStoresErrorFn(error: HTTPError): StoresAction {
  return {
    type: STORES_FETCH_ERROR,
    error,
  };
}

export function resetState(): StoresAction {
  return {
    type: STORES_RESET_STATE,
  };
}

export const actions = {
  STORES_FETCH_REQUEST,
  STORES_FETCH_SUCCESS,
  STORES_FETCH_ERROR,
  STORES_RESET_STATE,
  fetchStores,
  fetchStoresSuccess,
  fetchStoresErrorFn,
  resetState,
};

// export const SORTED_STORES = stores.sort(compareAsc);
export const initialState: StoresState = {};

const paginator = new Paginator(['stores']);

export default function reducer(state: StoresState = initialState,
                                action: StoresAction): StoresState {
  switch (action.type) {
    case STORES_FETCH_REQUEST:
      if (action.resetPagination) {
        paginator.reset('stores');
        return {
          isFetchingStores: true,
          stores: paginator.getItems('stores'),
          page: paginator.getPage('stores'),
          pageCanAsk: paginator.getCanAsk('stores'),
        };
      }
      return {
        ...state,
        isFetchingStores: true,
      };
    case STORES_FETCH_SUCCESS:
      paginator.increment('stores', action.stores, state.stores, 'slug');
      return {
        stores: paginator.getItems('stores'),
        page: paginator.getPage('stores'),
        pageCanAsk: paginator.getCanAsk('stores'),
      };
    case STORES_FETCH_ERROR:
      return {
        ...state,
        fetchStoresError: action.error,
      };
    case STORES_RESET_STATE:
      paginator.resetAll();
      return initialState;
    default:
      return state;
  }
}

// epics
export function fetchStoresEpic(action$: Observable<StoresAction>,
                                state$: StateObservable<RootState>): Observable<StoresAction> {
  return action$.pipe(
    ofType(STORES_FETCH_REQUEST),
    mergeMap(({ filters }) => {
      return getStoresApi({
        ...filters,
        // page: paginator.getPage('stores'),
        page: state$.value.stores.page || paginator.getPage('stores'),
        limit: paginator.getLimit(),
      }).pipe(
        takeUntil(action$.pipe(ofType(STORES_RESET_STATE))),
        takeUntil(action$.pipe(ofType(STORES_FETCH_REQUEST))),
        map((response: Category[]) => fetchStoresSuccess(response)),
        catchError((e: HTTPError) => of(fetchStoresErrorFn(e))))
    }));
}



// WEBPACK FOOTER //
// ./src/modules/stores/duck.js